
import React, { useState, memo, useMemo, useImperativeHandle, forwardRef, useEffect } from 'react';
import ValuesStore from '../store/values-store';

import utils from '../dependencies/custom/react-utilities';
import useTable from '../hooks/table';
// import useDelete from '../hooks/delete';
import Settings from '../dependencies/custom/settings';


const Table = ({ tableName, columns, checkableFilters, endpoint, render, onTableObjectReady }) => {
    // const valuesStore = ValuesStore();
    // const del = useDelete();    
    const { filters, filterTypes } = utils.generateTableFilters();
    //and key value that points to the table names from zustand store.    
    const table = useTable(
        {
            pagination: {
                current: 1,
                pageSize: 10,
                position: ['bottomRight', 'topRight'],
                hideOnSinglePage: true
            },
            filters: { ...filters },
            filterTypes: { ...filterTypes }
        },
        endpoint,
        'post',
        'result',
        'totalCount',
        'id',
        {},
        { table: tableName, fields: ['*'] });

    function processCols() {
        return columns?.map(v => {
            if (v?.columnSearch) {
                return { ...v, ...table?.getColumnSearchProps(v?.dataIndex) };
            }
            return v;
        });
    }

    useMemo(() => {
        table.setColumns(processCols());
        table.setColFilters(checkableFilters, columns, `${Settings.backend}/get_col_filters`);
        if (onTableObjectReady) {
            onTableObjectReady(() => table);
        }
    }, [table.extraFetchParams, render]);


    return (
        <>
            {table.table}
        </>
    );
}

export default memo(Table);